import React, { Component, PropsWithChildren } from 'react';

export default class DialogFooter extends Component<PropsWithChildren<any>> {
    public render() {
        return (
            <div className="dialog-footer">
                <div className="dialog-footer-options">{this.props.children}</div>
            </div>
        );
    }
}
